import React, { useState, useEffect } from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";
import Loc1 from "@/public/static/images/loc-c-01.png";
import icon from "@/public/static/images/l-icon.png";

import Local1 from "@/public/static/images/l-01.png";
import Local2 from "@/public/static/images/l-02.png";
import Local3 from "@/public/static/images/l-03.png";
import Local4_1 from "@/public/static/images/l-04_1.png";
import Local4_2 from "@/public/static/images/l-04_2.png";
import Local5 from "@/public/static/images/l-05.png";
import Local6 from "@/public/static/images/l-06.png";
import Local7 from "@/public/static/images/l-07.png";
import Local8 from "@/public/static/images/l-08.png";
import Local9 from "@/public/static/images/l-09.png";

import bgPa from "@/public/static/images/event-bg.png";

import DemoIMG from "@/public/static/images/demo_img.png";

declare global {
  interface Window {
    gtag: (
      event: string,
      action: string,
      params: { [key: string]: any }
    ) => void;
  }
}

const Localization = () => {
  useEffect(() => {
    // เรียกใช้งาน gtag สำหรับ Conversion Tracking
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-11490672773/hkBVCKDAiPYZEIWBl-cq",
        value: 1.0,
        currency: "THB",
      });
    }
  }, []);
  const img: any = "/static/images/s-loc.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };
  return (
    <>
      <div className="wrapper">
        <Header />
        <section className="key_visual">
          <motion.img
            // animate={imgAnimation}
            // onMouseMove={(e) => handleMouseMove(e)}
            src={img}
            alt="LOCALIZATION"
            loading="lazy"
          />
          <div className="img-bg" />
        </section>

        <section className="sv_content event-content">
          <div className="container">
            <div className="row">
              <div className="col-12 heading-top_content">
                <div className="d-flex justify-content-center">
                  <h2>Localization</h2>
                </div>
              </div>
              <div className="col-12 sv_content-inner">
                <p className="mb-3">
                  ITP Asia supplies translation services for more than 20
                  languages We not only have the biggest translations center
                  among the ITP Group's overseas bases, but we are also{" "}
                  <span className="fw-bolder">
                    proficient in translating Southeast Asian languages like
                    Thai, Burmese, Malay, Khmer, Tagalog, Lao, Vietnamese,
                  </span>{" "}
                  etc.
                </p>
                <p className="mb-3">
                  ITP Asia is the{" "}
                  <span className="fw-bolder">
                    biggest Japanese company in localization business in
                    Thailand.
                  </span>{" "}
                  Since our opening in Thailand in 1999, ITP Asia has translated
                  almost <span className="fw-bolder">200 million words.</span>{" "}
                  In 2020 we successfully developed the first English to Thai{" "}
                  <span className="fw-bolder">“AI translation”</span> technology
                  in the world for{" "}
                  <span className="fw-bolder">the Thai automobile</span>
                  sector, with machine learning utilizing big data. We then
                  began to offer AI translation services to automotive clients
                  in Thailand. Currently, more than 40% of the automobile
                  owner's manuals in Thailand have been translated using ITP's
                  AI translation technology.
                </p>
                <p className="mb-4">
                  In the future, ITP Asia will extend the AI translation
                  technology to Southeast Asian languages translation. This will
                  make translators more valuable while continuing to offer
                  unique and high-quality translation services through working
                  with AI.
                </p>

                <ul>
                  <li>Manuals</li>
                  <li>Training book</li>
                  <li>Catalog ＆ Leaflet</li>
                  <li>Movie</li>
                  <li>Website</li>
                  <li>E-learning</li>
                  <li>Marketing message, PR</li>
                  <li>Technical documents.</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="sv_content black-content">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center ev-heading-spr_bl mb-5">
                <h1 className="fw-bolder t-green">
                  Fast, Smart, Accurate, Worthy
                </h1>
                <h2 className="t-white">
                  Localize your business with ITP Asia gives you an impressive
                  experience,
                  <br />
                  high quality product, with our detail-oriented one-stop
                  service
                </h2>
              </div>
            </div>
            <div className="row mb-5">
              <div className="col-12 col-md-6 mb-3 port-service">
                <div className="card h-100">
                  <Image
                    loading="lazy"
                    src={Loc1}
                    alt="Exhibition / Booth / Fair"
                    className="img-fluid mx-auto"
                  />
                </div>
              </div>
              <div className="col-12 col-md-6 mb-3 port-service">
                <div className="card h-100">
                  <div className="card-body t-white">
                    <h1 className="t-green mb-4">
                      Localization really matters
                    </h1>
                    <h4 className="mb-4">
                      As the world globalized, it is a lot easier for your
                      business to enter new markets. On the other hand, other
                      business is finding their ways to reach new markets too.
                    </h4>
                    <h4 className="mb-4">
                      To be able to compete, Localization is a key to your
                      success in entering new markets with different languages,
                      cultures, or needs, comparing to non-localized business.{" "}
                    </h4>
                    <h4 className="mb-4">
                      As Localization let you tailor your products and services
                      to meet the needs and preferences of your target audience,
                      it is the advantage of your business to compete in this
                      globalization era.
                    </h4>
                  </div>
                  <div className="card-footer t-white"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sv_content gray-content">
          <div className="container">
            <div className="row justify-content-md-center mt-5">
              <div className="col-12 col-md-4 card-sv card-event">
                <div className="card h-100 text-center">
                  <Image
                    loading="lazy"
                    src={Local1}
                    alt="Communication"
                    className="img-fluid mx-auto"
                  />
                  <div className="card-body">
                    <h2 className="mb-0 lh-1">Better</h2>
                    <h2 className="card-title t-green fw-bolder">
                      Communication
                    </h2>
                    <p>
                      Build trust and establish a strong connection with your
                      value customers by localizing your products and services
                      for more effective communication.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 card-sv card-event">
                <div className="card h-100 text-center">
                  <Image
                    loading="lazy"
                    src={Local2}
                    alt="Brand Awareness"
                    className="img-fluid mx-auto"
                  />
                  <div className="card-body">
                    <h2 className="mb-0 lh-1">Brand</h2>
                    <h2 className="card-title t-green fw-bolder">
                      Recognition
                    </h2>
                    <p>
                      Building brand recognition in local markets through
                      localization. This will also increase competitive
                      advantage of your business over others with no localized
                      products and services.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4 card-sv card-event">
                <div className="card h-100 text-center">
                  <Image
                    loading="lazy"
                    src={Local3}
                    alt="Networking Opportunities"
                    className="img-fluid mx-auto"
                  />
                  <div className="card-body">
                    <h2 className="mb-0 lh-1">Increased</h2>
                    <h2 className="card-title t-green fw-bolder">
                      Reach & Sales
                    </h2>
                    <p>
                      Localization let your products and services reach a
                      broader audience and appeal to local consumers. Your
                      business can meet the specific needs and attract new
                      customers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 text-center ev-heading-spr_bl my-5">
                <h1 className="fw-bolder t-green">
                  Localization with ITP Asia
                </h1>
                <h2 className="">
                  We provide a full service of all you need at once
                  <br />
                  From Pre-process of Translation to Ready-to-Publish
                </h2>
              </div>
            </div>
            <div className="row justify-content-md-center aling-item-center mt-5">
              <div className="col-12 col-md-3 card-sv card-event">
                <div className="card h-100 text-center">
                  <Image
                    loading="lazy"
                    src={Local4_1}
                    alt="Database Translation & AI Translation"
                    className="img-fluid mx-auto"
                  />
                  <div className="card-body pb-0">
                    <h2 className="card-title mb-0 lh-1">
                      Database Translation
                      <br />
                      &<br />
                      AI Translation
                    </h2>
                    <h1 className="t-green fw-bolder mb-0 lh-1">+</h1>
                  </div>
                  <Image
                    loading="lazy"
                    src={Local4_2}
                    alt="Communication"
                    className="img-fluid mx-auto"
                  />
                  <h2>Translator</h2>
                </div>
              </div>
              <div className="col-12 col-md-1 d-none d-sm-flex card-sv card-event d-flex align-items-center ">
                <div className="">
                  <Image
                    loading="lazy"
                    src={icon}
                    alt="icon"
                    className="img-fluid mx-auto"
                  />
                </div>
              </div>
              <div className="col-12 col-md-3 card-sv card-event">
                <div className="card h-100 text-center mt-5">
                  <Image
                    loading="lazy"
                    src={Local5}
                    alt="Layout Adjustment & Page Creation"
                    className="img-fluid mx-auto"
                  />
                  <div className="card-body">
                    <h2 className="mb-0 lh-1">
                      Layout Adjustment & Page Creation
                    </h2>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-1 d-none d-sm-flex card-sv card-event d-flex align-items-center ">
                <div className="">
                  <Image
                    loading="lazy"
                    src={icon}
                    alt="icon"
                    className="img-fluid mx-auto"
                  />
                </div>
              </div>
              <div className="col-12 col-md-3 card-sv card-event">
                <div className="card h-100 text-center mt-5">
                  <Image
                    loading="lazy"
                    src={Local6}
                    alt="Ready to use For any purpose!"
                    className="img-fluid mx-auto"
                  />
                  <div className="card-body">
                    <h2 className="mb-0 lh-1">Ready to use For any purpose!</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 text-center ev-heading-spr_bl my-3">
                <h2 className="">We also support</h2>
              </div>
            </div>
            <div className="row justify-content-md-center gap-3 aling-item-center">
              <div className="col-12 col-md-3 card-sv card-event">
                <div className="card h-100 text-center">
                  <Image
                    loading="lazy"
                    src={Local7}
                    alt="Communication"
                    className="img-fluid mx-auto"
                  />
                </div>
              </div>
              <div className="col-12 col-md-3 card-sv card-event">
                <div className="card h-100 text-center">
                  <Image
                    loading="lazy"
                    src={Local8}
                    alt="Communication"
                    className="img-fluid mx-auto"
                  />
                </div>
              </div>
              <div className="col-12 col-md-3 card-sv card-event">
                <div className="card h-100 text-center">
                  <Image
                    loading="lazy"
                    src={Local9}
                    alt="Communication"
                    className="img-fluid mx-auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sv_content black-content">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-6 mb-3 port-service">
                <div className="card h-100">
                  <h1 className="t-white subject-half text-center">
                    Reasons why <br />
                    you should <br />
                    <span className="t-green fw-bold">Localize</span> <br />
                    with ITP Asia
                  </h1>
                </div>
              </div>
              <div className="col-12 col-md-6 port-service ">
                <div className="card h-100">
                  <div className="row">
                    <div className="col-12 lo_rea">
                      <div className="row">
                        <div className="col-2 num-text">
                          <div className="num-i d-flex justify-content-center align-items-center t-white fw-bolder">
                            1
                          </div>
                        </div>
                        <div className="col-10 num-text_inner">
                          <p className="t-white">
                            We specialize in{" "}
                            <span className="t-green fw-bold">
                              Technical, Marketing and Legal translation
                            </span>{" "}
                            <br />
                            supporting Automobile, Robot, Home Appliance,
                            Cutting tools, Housing, Building materials,
                            Construction, Medical, Food, Tourism businesses.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 lo_rea">
                      <div className="row">
                        <div className="col-2 num-text">
                          <div className="num-i d-flex justify-content-center align-items-center t-white fw-bolder">
                            2
                          </div>
                        </div>
                        <div className="col-10 num-text_inner">
                          <p className="t-white">
                            <span className="t-green fw-bold">
                              More than 2 decades of experience
                            </span>{" "}
                            <br />
                            We have translated
                            <br />
                            almost{" "}
                            <span className="t-green fw-bold">
                              200 million
                            </span>{" "}
                            words
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-2 num-text">
                          <div className="num-i d-flex justify-content-center align-items-center t-white fw-bolder">
                            3
                          </div>
                        </div>
                        <div className="col-10 num-text_inner">
                          <p className="t-white">
                            <span className="t-green fw-bold">
                              Database Translation & AI Translation
                            </span>{" "}
                            <br />
                            that we offer can benefit you by
                          </p>
                          <ul>
                            <li>Reducing translation cost</li>
                            <li>Enhancing translation quality</li>
                            <li>Shortening translation timeline</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="sv_content gray-content">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center ev-heading-spr mb-4">
                <h1 className="fw-bold t-green">We do localize these</h1>
              </div>
            </div>
            <div className="row row-cols-1 row-cols-md-2 g-4">
              <div className="col document-box mb-3">
                <div className="card h-100">
                  <div className="card-header">
                    <h2 className="t-white fw-bold mb-0">Document</h2>
                    <h2 className="t-green mb-0">attached with products</h2>
                  </div>
                  <div className="card-body">
                    <div className="document-box_inner">
                      <ul>
                        <li>User’s manual / Owner’s manual</li>
                        <li>Warranty book</li>
                        <li>Installation guide</li>
                        <li>Label</li>
                        <li>Caution sheet</li>
                        <li>Maintenance book</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col document-box mb-3">
                <div className="card h-100">
                  <div className="card-header">
                    <h2 className="t-white fw-bold mb-0">Document</h2>
                    <h2 className="t-green mb-0">
                      attributed to dealers and shops
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="document-box_inner">
                      <ul>
                        <li>Repair manual / Service manual</li>
                        <li>Maintenance sheet</li>
                        <li>
                          Maintenance education tools (poster, book, goods etc.)
                        </li>
                        <li>Catalog</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col document-box mb-3">
                <div className="card h-100">
                  <div className="card-header">
                    <h2 className="t-white fw-bold mb-0">Document</h2>
                    <h2 className="t-green mb-0">for training</h2>
                  </div>
                  <div className="card-body">
                    <div className="document-box_inner pb-5">
                      <ul>
                        <li>Training manual</li>
                        <li>Check sheet, Evaluation sheet</li>
                        <li>BP manual, Dealer management manual</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col document-box mb-3">
                <div className="card h-100">
                  <div className="card-header">
                    <h2 className="t-white fw-bold mb-4">Digital Media</h2>
                  </div>
                  <div className="card-body">
                    <div className="document-box_inner pb-5">
                      <ul>
                        <li>Diagnosis machine / Car Navi UI localization</li>
                        <li>Website localization</li>
                        <li>VDO script, subtitle localization</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12 text-center ev-heading-spr">
                <h1 className="mt-4 mb-0">And many more!</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="sv_content green-content">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center ev-heading-spr_bl">
                <h1 className="fw-bolder">Contact us today !</h1>
                <h2 className="lh-1 mb-0">
                  and let us know how we can assist you in Localize your
                  business
                  <br />
                  because at ITP Asia, any of your project does matter.
                </h2>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default Localization;
